.inner {
    composes: safeContainer from "./composable/layout.module.css";
    padding-bottom: var(--spacer-80);
}

.heading {
    padding-block: var(--spacer-80);
    font: var(--font-h-64);
    text-align: center;
}
